export default () => ({
  commands: {
    changeBlock: (editor, type) => {
      // TODO: A bug in slate tries to resolve the selection before the editor
      // is actually refocused. It only happens when the editor is empty.
      // Fixing the bug in slate itself would be ideal, but we're behind
      // a version and need to migrate our data before we can do that.
      // This is a workaround that inserts a space, which keeps the editor
      // from being empty when the selection is resolved. In then deletes
      // that space right after. This is super sketchy.
      if (editor.value.selection.isCollapsed) {
        editor
          .setBlocks(type)
          .insertText(" ")
          .focus()

        setTimeout(() => {
          editor.deleteBackward()
        }, 1)
      } else {
        editor
          .setBlocks(type)
          .focus()
          .moveToEndOfBlock()
      }
    }
  }
})
